import { Module } from "vuex";
import { getters } from "./getters";
import { actions } from "./actions";
import { mutations } from "./mutations";
import { TasksState } from "./types";
import { RootState } from "../types";
import { getDefaultState } from "./state";

export const state: TasksState = getDefaultState();

const namespaced: boolean = true;

export const tasks: Module<TasksState, RootState> = {
	namespaced,
	state,
	getters,
	actions,
	mutations
};
